import React, { useContext } from "react";
import { MediaQueriesContext } from "../../App";
import s from "./responsiveButtonGroup.scss";

const ResponsiveButtonGroup = ({ buttonElements, className, warningElement = null }) => {
  const { isMediaMobile } = useContext(MediaQueriesContext);

  if (isMediaMobile) {
    return (
      <div className={s.responsiveButtonGroup}>
        {warningElement}
        <div className={s.buttons}>{buttonElements}</div>
      </div>
    );
  }

  return (
    <div className={className}>
      {warningElement ? warningElement : null}
      {buttonElements}
    </div>
  );
};

export default ResponsiveButtonGroup;
